<template>
  <div id="app">
    <transition :name="transitionName" mode="out-in">
      <router-view/>
    </transition>
    <Footer></Footer>
    <Cookie></Cookie>
  </div>
</template>

<script>
import Footer from './components/Footer.vue'
import Cookie from './components/Cookie.vue'
import InArray from './components/helpers/inArray'
import MainPages from './router/mainPages'

export default {
  name: 'App',
  data: function () {
    return {
      transitionName: ''
    }
  },
  components: {
    Footer,
    Cookie
  },
  watch: {
    '$route' (to, from) {
      if (InArray(to.name, MainPages)) {
        this.transitionName = 'fade'
      } else {
        this.transitionName = ''
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
  @import './assets/css/style.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue